// @flow

import * as React from 'react';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import LoginForm from '../components/LoginForm';
import { HistoryContext } from '../../../context/history.context';
import { DesktopView, MobileView } from '../../../config/mediaQuery';

const LoginFormLayout = () => (
  <>
    <DesktopView>
      <Grid>
        <Row className="show-grid">
          <Col xs={12} md={4} mdOffset={4}>
            <HistoryContext.Consumer>
              {history => <LoginForm history={history} />}
            </HistoryContext.Consumer>
          </Col>
        </Row>
      </Grid>
    </DesktopView>
    <MobileView>
      <HistoryContext.Consumer>
        {history => <LoginForm history={history} />}
      </HistoryContext.Consumer>
    </MobileView>
  </>
);

export default LoginFormLayout;
